module.exports = __webpack_public_path__ + "1677a1b7faed64265d0eac20cb29c2a4.svg";